import { Replay } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

function ReloadIcon({title="Refresh", sx={}, onClick}:{title?:string, sx?: object, onClick:()=>any}) {
  return (<Tooltip title={title} sx={{mx:'2px',verticalAlign:'bottom',fontSize:14,cursor:'pointer',color:'primary.light', ...sx}} onClick={onClick} enterTouchDelay={0}><Replay/></Tooltip>
  );
}
export default ReloadIcon;